import { alpha, svgIconClasses } from '@mui/material';

import type { Theme } from '@mui/material';

const styles = {
  icon: {
    color: 'primary.main',
    fontSize: 40,
    mb: 1.5,
  },
  caption: {
    mt: 2,
    color: 'gray.600',
  },
  zone: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px dashed',
    borderColor: 'primary.main',
    borderRadius: 1,
    p: 2.5,
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.03),
  },
  active: {
    borderColor: 'success.main',
    backgroundColor: (theme: Theme) => alpha(theme.palette.success.main, 0.03),
    [`& > .${svgIconClasses.root}`]: {
      color: 'success.main',
    },
  },
  previewContainer: {
    mt: 2.5,
    minHeight: 64,
    display: 'flex',
    flexWrap: 'wrap',
    '& > a': {
      alignItems: 'center',
      justifyContent: 'center',
      color: 'primary.main',
    },
  },
  preview: {
    width: 88,
    height: 88,
    mb: 2.5,
    mr: 1,
    objectFit: 'cover',
    borderRadius: 1.5,
    display: 'flex',
    flexShrink: 0,
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.03),
  },
  removeButton: {
    position: 'relative',
    ml: -5,
    height: 40,
    mt: -1,
  },
} as const;

export default styles;
